import BucketApiRequest from "./BucketApiRequest";
import { GET_FI_INFO_URL } from "../ApiUrls";

export default class GetFinInfoApiRequest extends BucketApiRequest {
  getUrl = () => {
    return GET_FI_INFO_URL;
  };
}
